export default __webpack_public_path__ + "static/media/GPA24070B_background.19b22e3b.jpg";